var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecorder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 10.3333C9.4735 10.3333 10.6668 9.13992 10.6668 7.66659V3.99992C10.6668 2.52659 9.4735 1.33325 8.00016 1.33325C6.52683 1.33325 5.3335 2.52659 5.3335 3.99992V7.66659C5.3335 9.13992 6.52683 10.3333 8.00016 10.3333Z",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8999 6.43335V7.56668C2.8999 10.38 5.18657 12.6667 7.9999 12.6667C10.8132 12.6667 13.0999 10.38 13.0999 7.56668V6.43335",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07324 4.28658C7.67324 4.06658 8.32658 4.06658 8.92658 4.28658",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4668 5.69988C7.82013 5.60655 8.1868 5.60655 8.54013 5.69988",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6667V14.6667",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorder);
export default __webpack_public_path__ + "static/media/recorder.2947d68454336aaf07f54cfe755b7b6a.svg";
export { ForwardRef as ReactComponent };